import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const tabsStyles = {
  root: {
    border: '1px solid #e8e8e8',
  },
};

export const useGradientStyles = makeStyles((theme) => ({
  root: {
    opacity: 1,
    position: 'absolute',
    height: 50,
    zIndex: 2,
  },
  left: {
    left: 0,
    background: 'linear-gradient(90deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 60%, rgba(255, 255, 255, 0) 100%)',
    zIndex: 3,
  },
  right: {
    right: 0,
    background: 'linear-gradient(-90deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 60%, rgba(255, 255, 255, 0) 100%)',
    zIndex: 3,
  },
}));

export const tabStyles = {
  root: {
    minWidth: 102,
    maxWidth: 102,
    borderRight: '1px solid rgb(240, 240, 240)',
    opacity: 0.5,
  },
  selected: {
    opacity: 1,
  },
};

export const useRootStyles = makeStyles((theme) => ({
  root: {
    // flexGrow: 1,
    // Strange behaviour when child container overflows parent with width set to 100%
    // width: 'calc(100% - 32px)',
  },
  translation: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  relative: {
    position: 'relative',
  },
  errorTab: {
    borderBottom: '2px solid red',
    zIndex: 1,
  },
}));

export const useContainerStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export const useLabelStyles = makeStyles((theme) => ({
  label: {
    color: 'black',
    fontSize: 16,
  },
  error: {
    color: 'red',
  },
}));

export const useCurrencyStyle = makeStyles((theme: Theme) => ({
  flagIcon: {
    minWidth: 22,
    minHeight: 16,
    marginLeft: 8,
    marginRight: 14,
  },
  label: {
    fontSize: 16,
    fontWeight: 'normal',
    textTransform: 'uppercase',
    display: 'inline-block',
  },
}));
